import axios from "axios";

const errorResponseObject = {
  success: false,
  error: "Sorry there seems to be an internal server error",
};

const toErrorResponse = (error) => {
  const data = error?.data || error?.response?.data || {};
  const message =
    (typeof data.error === "string" && data.error) ||
    data.message ||
    data.server?.message ||
    data.error?.message;
  return message ? { success: false, error: message } : errorResponseObject;
};

const apiRequests = {
  getRequest: async (url) => {
    try {
      const res = await axios.get(`${url}`);
      return res;
    } catch (error) {
      console.error("Get request error", error);
      return toErrorResponse(error);
    }
  },
  postRequest: async (url, body) => {
    try {
      const res = await axios.post(`${url}`, body);
      return res;
    } catch (error) {
      console.error("Post Request Error", error);
      return toErrorResponse(error);
    }
  },
  putRequest: async (url, body) => {
    try {
      const res = await axios.put(`${url}`, body);
      return res;
    } catch (error) {
      console.error("Put request error", error);
      return toErrorResponse(error);
    }
  },
  patchRequest: async (url, body) => {
    try {
      const res = await axios.patch(`${url}`, body);
      return res;
    } catch (error) {
      console.error("Patch request error", error);
      return toErrorResponse(error);
    }
  },
  deleteRequest: async (url) => {
    try {
      const res = await axios.delete(`${url}`);
      return res;
    } catch (error) {
      console.error("Delete request error", error);
      return toErrorResponse(error);
    }
  },
  filePostRequest: async (path, body) => {
    try {
      const res = await axios.post(`${path}`, body);
      return res;
    } catch (error) {
      console.error("File post error", error);
      return toErrorResponse(error);
    }
  },
};

export default apiRequests;
